import React from 'react'

import softTissue from '../../images/SOFT_TISSUE.jpg'
import softTissue3 from '../../images/SOFT TISSUE 3,.jpg'
import softTissue8 from '../../images/SOFT TISSUE 8.jpg'
import softTissue9 from '../../images/SOFT TISSUE 9.jpg'
import softTissue10 from '../../images/SOFT TISSUE 10.jpg'

function SoftTissue() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={softTissue}
            className="project-image" />
          <img
            src={softTissue9}
            className="project-image" />
          <img
            src={softTissue10}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Soft Tissue</h1>
          <p className="Project-text">
            <strong>
              Ella Gilbert - Creator, Performer
            <br />
            Jade Eriksen - Creator, Director
            <br />
            Michael Trigg - Lighting Designer
            <br />
            Anuwela Howarth - Costume Designer
            </strong>
          </p>
          <p className="Project-testimonial">
            Nominations:
            <br />
NZ Fringe Festival 2019
            <br />
OUTSANDING PERFORMER - Ella Gilbert
            <br />
MOST PROMISING EMERGING ARTIST - Ella Gilbert
<br />
<br />
            Wellington Theatre Awards 2018
            <br />
MOST PROMISING NEWCOMER - Ella Gilbert
          </p>
          <p className="Project-testimonial">
            She displays a total and detailed command of her body that is utterly mesmerising.
            This is a work and a performer that will stay in your mind long after the lights have gone down.
          </p>
          <h6 className="Testimonial-person">
            <strong>~Theatreview</strong>
          </h6>
          <p className="Project-testimonial">
            Ella Gilbert’s solo show hits me on a gut level and has me on the edge of my seat for the entire hour
          </p>
          <h6 className="Testimonial-person">
            <strong>~Theatreview</strong>
          </h6>
          <p className="Project-testimonial">
            Like a David Lynch Film. Ambiguous, beguiling and oddly unsettling
          </p>
          <h6 className="Testimonial-person">
            <strong>~Theatrescenes</strong>
          </h6>
          <p className="Project-text">
            A solo devised show created by Ella Gilbert and Jade Eriksen.
            Conceived in 2014 in Ella's first year of actor training at Toi Whakaari Drama School.
            The show went on to be performed in Singapore, Tehran, Arohata Women's prison and Manutuke Marae. With sell out seasons at Bats Theatre and Basement Theatre, 2017, 2018 and 2019.
          </p>
        </div>
      </div>
    </div>
  )
}

export default SoftTissue
